import { fail } from "@sveltejs/kit";
import auth from "../../../../chunks/auth.js";
import { p as prisma } from "../../../../chunks/prisma.js";
import { s as sendEmail } from "../../../../chunks/mailService.js";
import { d as RECAPTCHA_SECRET_KEY } from "../../../../chunks/private.js";
import { a as validateRegistration } from "../../../../chunks/index4.js";
const load = (async ({ locals }) => {
});
const actions = {
  default: async ({ request, url, fetch }) => {
    const formData = Object.fromEntries(await request.formData());
    const validation = validateRegistration(formData);
    if (!validation.success) {
      return fail(400, {
        data: formData,
        errors: validation.errors
      });
    }
    const {
      name,
      email,
      phoneNumber,
      idNumber,
      password,
      postalCode,
      address,
      "g-recaptcha-response": recaptchaToken
    } = validation.data;
    try {
      const secret = RECAPTCHA_SECRET_KEY;
      if (!secret) ;
      const user = await prisma.user.findUnique({
        where: { email: email.toString() }
      });
      if (user) {
        return fail(400, {
          data: { name, email, phoneNumber, idNumber },
          errors: { email: ["Email is already in use. Please log in."] }
        });
      }
      const verificationURL = "https://www.google.com/recaptcha/api/siteverify";
      const response = await fetch(verificationURL, {
        method: "POST",
        body: new URLSearchParams({
          secret,
          response: recaptchaToken
        })
      });
      const verificationRes = await response.json();
      console.log("reCAPTCHA verification data: \n ", verificationRes);
      const hashedPassword = await auth.hash(password.toString());
      const newUser = await prisma.user.create({
        data: {
          name: name.toString(),
          email: email.toString(),
          idNumber: parseInt(idNumber),
          phoneNumber: phoneNumber.toString(),
          password: hashedPassword,
          postalCode: postalCode.toString(),
          address: address.toString(),
          role: { connect: { name: "USER" } }
        }
      });
      const token = auth.generateEmailVerificationToken(newUser.email);
      const link = url.origin + `/verify?token=${token}`;
      const isEmailSent = await sendEmail(newUser.email, `${newUser.name}, Verify Your Email`, "verify-email", {
        username: name,
        origin: url.origin,
        link
      });
      console.log("Email Sent?: ", isEmailSent);
      return { status: 200, body: { message: "User created successfully", isEmailSent } };
    } catch (e) {
      console.log(e);
      return fail(500, {
        data: { name, email, phoneNumber, idNumber, address, postalCode },
        errors: { _errors: ["An unexpected error occurred"] }
      });
    }
  }
};
export {
  actions,
  load
};
